module.exports = __webpack_public_path__ + "img/1.9fd9b2b8.png";